function registerCustomEffects() {
  // textReveal
  gsap.registerEffect({
    name: "textReveal",
    effect: (target, {duration, delay, scrollTrigger}) => {
      return gsap.fromTo(target, {
        opacity: 0,
        y: '2em',
      }, {
        opacity: 1,
        y: '0em',
        ease: 'power2.out',
        delay: delay,
        duration: duration,
        stagger: 0.08,
        immediateRender: true,
        lazy: false,
        scrollTrigger: scrollTrigger
      });
    },
    defaults: {duration: 1.5, delay: 0},
    extendTimeline: true,
  });
  
  // imageReveal
  gsap.registerEffect({
    name: "imageReveal",
    effect: (target, {duration, delay, scrollTrigger}) => {
      return gsap.fromTo(target, {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
      }, {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        duration: duration,
        ease: 'power2.in',
        delay: delay,
        immediateRender: true,
        lazy: false,
        scrollTrigger: scrollTrigger
      })
    },
    defaults: {duration: 1.5, delay: 0},
    extendTimeline: true,
  });
  
  // parallax
  gsap.registerEffect({
    name: "parallax",
    effect: (target, {scrollTrigger}) => {
      return gsap.fromTo(target, {
        yPercent: -25,
      }, {
        yPercent: 25,
        ease: 'none',
        immediateRender: true,
        lazy: false,
        scrollTrigger: scrollTrigger,
      })
    },
    extendTimeline: true,
  });
}